module.exports = __webpack_public_path__ + "img/stadia-ios-ipad-home-framed.7f4f98c2.webp";